import { Button, styles, Text, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React from 'react';

import * as style from './Skeleton.module.css';
import { IS_JEST } from '../../helpers';

const LIPSUM =
  "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.";

const Skeleton = ({ base = false, button = false, children, icon = false, words = 0, ...others }) => {
  const is = {
    button,
    icon,
    text: words > 0 || typeof children === 'string',
  };

  return React.createElement(
    button ? Button : is.text ? Text : View,
    {
      ...others,
      className: styles(
        style.skeleton,
        base && style.base,
        is.button ? style.button : is.icon ? style.icon : is.text ? style.text : undefined,
        others.className,
      ),
    },
    words > 0
      ? LIPSUM.split(' ')
          .sort(() => (IS_JEST ? 1 : Math.random() - 0.5))
          .slice(0, words)
          .join(' ')
      : children,
  );
};

Skeleton.displayName = 'Mirai:Core:Skeleton';

Skeleton.propTypes = {
  base: PropTypes.bool,
  button: PropTypes.bool,
  children: PropTypes.any,
  icon: PropTypes.bool,
  words: PropTypes.number,
};

export { Skeleton };
